// kh-main.js — Scroll-Fortschritt, Einblendungen, Toast
//
// Bis zum 02.09.2026 lief das ueber GSAP, ScrollTrigger und anime.js:
// zusammen 130 KB fuer 13 Aufrufstellen im ganzen Theme. Ersetzt durch
// IntersectionObserver und CSS-Uebergaenge; die Datei bleibt unter 3 KB.
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  ready(function () {

    // ── Scroll-Fortschritt ────────────────────────────────────────────
    // Vorher ScrollTrigger mit scrub. Ein passiver Listener mit
    // requestAnimationFrame kommt auf dasselbe Ergebnis, ohne Bibliothek.
    var balken = document.getElementById('kh-progress');
    if (balken) {
      var geplant = false;
      var zeichne = function () {
        geplant = false;
        var hoehe = document.documentElement.scrollHeight - window.innerHeight;
        var anteil = hoehe > 0 ? Math.min(1, window.scrollY / hoehe) : 0;
        balken.style.transform = 'scaleX(' + anteil + ')';
      };
      window.addEventListener('scroll', function () {
        if (geplant) return;
        geplant = true;
        requestAnimationFrame(zeichne);
      }, { passive: true });
      zeichne();
    }

    // ── Einblendungen: data-kh-reveal="up|left|right" ──────────────────
    // Der Startzustand wird erst hier gesetzt, nicht im Stylesheet: faellt
    // JavaScript aus, bleibt der Inhalt sichtbar statt dauerhaft leer.
    var ziele = document.querySelectorAll('[data-kh-reveal]');
    if (ziele.length && !wenigBewegung && 'IntersectionObserver' in window) {
      ziele.forEach(function (el, i) {
        el.classList.add('kh-reveal-start');
        el.style.transitionDelay = ((i % 4) * 0.06) + 's';
      });
      var beob = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('kh-reveal-los');
          beob.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -22% 0px' });
      ziele.forEach(function (el) { beob.observe(el); });

      // Wachhund: nichts darf unsichtbar bleiben, falls der Beobachter
      // nicht ausloest (Hintergrund-Tab, sehr kurze Seite).
      setTimeout(function () {
        ziele.forEach(function (el) { el.classList.add('kh-reveal-los'); });
      }, 3000);
    }
  });

  // ── Toast ───────────────────────────────────────────────────────────
  var zeitgeber;
  window.khToast = function (titel, unterzeile) {
    clearTimeout(zeitgeber);
    var t = document.getElementById('kh-toast');
    if (!t) return;
    var tt = document.getElementById('kh-toast-title');
    var ts = document.getElementById('kh-toast-sub');
    if (tt) tt.textContent = titel || '';
    if (ts) ts.textContent = unterzeile || '';
    // Das Symbol wird bewusst NICHT gesetzt: es steht als SVG im Markup
    // (snippets/kh-icon.liquid). Vorher schrieb diese Funktion ein Emoji
    // hinein und ueberschrieb das Icon damit.
    var b = document.getElementById('kh-toast-bar');
    if (b) { b.style.animation = 'none'; void b.offsetWidth; b.style.animation = 'kh-drain 3s linear forwards'; }
    t.style.transition = 'opacity .4s cubic-bezier(.16,1,.3,1), transform .4s cubic-bezier(.16,1,.3,1)';
    t.style.opacity = '1';
    t.style.transform = 'translateX(-50%) translateY(0)';
    zeitgeber = setTimeout(function () {
      t.style.transition = 'opacity .3s ease-in, transform .3s ease-in';
      t.style.opacity = '0';
      t.style.transform = 'translateX(-50%) translateY(16px)';
    }, 3200);
  };

  var stil = document.createElement('style');
  stil.textContent = '@keyframes kh-drain{from{transform:scaleX(1)}to{transform:scaleX(0)}}';
  document.head.appendChild(stil);
})();
